(() => {
  "use strict";
  var e = {
      d: (t, n) => {
        for (var i in n)
          e.o(n, i) &&
            !e.o(t, i) &&
            Object.defineProperty(t, i, { enumerable: !0, get: n[i] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  e.r(t), e.d(t, { default: () => Se });
  var n = !1;
  const i = { success: 100, invalid: -50, unsupported: -100, error: -200 },
    a = "agreement",
    o = "applePay",
    s = { black: "black", white: "white", whiteOutline: "white-outline" },
    r = {
      buy: "buy",
      pay: "pay",
      plain: "plain",
      order: "order",
      donate: "donate",
      continue: "continue",
      checkout: "check-out",
    },
    d = {
      address_validation: "address_validation",
      support_recurring: "support_recurring",
      support_subscription: "support_subscription",
    },
    l = "igp",
    c = { client: "client", server: "server" };
  function u(e) {
    e &&
      arguments.length > 1 &&
      void 0 !== arguments[1] &&
      arguments[1] &&
      ("string" == typeof e
        ? console.log(JSON.stringify(e))
        : "object" == typeof e &&
          (e.label && e.data
            ? console.log(e.label, JSON.stringify(e.data))
            : console.log(JSON.stringify(e))));
  }
  function p(e, t) {
    const n = [];
    e && n.push(e),
      t &&
        ("string" == typeof t
          ? n.push(t)
          : "string" == typeof t.message
            ? n.push(t.message)
            : n.push(JSON.stringify(t))),
      console.error.apply(console.error, n);
  }
  function m(e) {
    if (!e) return null;
    if ("function" == typeof e) return e;
    if ("string" == typeof e) {
      let t,
        n = e.split("."),
        i = window;
      for (let e = 0; e < n.length; e++) (t = i), (i = i[n[e]]);
      return "function" == typeof i ? i.bind(t) : null;
    }
    throw new Error("Invalid function value");
  }
  function f(e, t) {
    return Number(e).toFixed(t);
  }
  function h(e, t) {
    return Number(f(e, t));
  }
  function g(e) {
    return null != e;
  }
  function y(e) {
    let t =
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    return e ? e.message || JSON.stringify(e) : t || JSON.stringify(e);
  }
  const v = {
      handleEvent: async function (e, t, n) {
        this.validateEvent(e, t);
        const i = await (async (t, n) => {
          if (!n) throw new Error("handleEvent: Invalid event params");
          if ("string" == typeof n)
            try {
              n = JSON.parse(n);
            } catch (e) {
              throw (
                (p("Failed to resolve event params object", e),
                "handleEvent: Failed to resolve callback params object")
              );
            }
          if (!n) throw new Error("handleEvent: Event params object is empty");
          if (!n.eventName) throw new Error("handleEvent: Invalid event name");
          const i = this.getEventOwner(e, t);
          let a = n.eventArgs;
          a && !Array.isArray(a) && (a = [a]);
          const o = {
            eventType: n.eventType || "function",
            eventName: n.eventName,
            eventArgs: a,
          };
          try {
            return { response: await this.executeEventHandler(i, o) };
          } catch (e) {
            return (
              p("handleEvent", e),
              { error: y(e, "No error description available") }
            );
          }
        })(t.tokenType, t.eventParams.client);
        if (t.eventParams.server && n) {
          const e = t.eventParams.server,
            a =
              "promise" === e.eventType
                ? i.error
                  ? "reject"
                  : "success"
                : e.eventType || "function";
          let o = [];
          e.eventArgs &&
            (o = Array.isArray(e.eventArgs) ? e.eventArgs : [e.eventArgs]),
            o.push(i.response || i.error);
          const s = {
              client: { eventType: a, eventName: e.eventName, eventArgs: o },
            },
            r = { tokenType: t.tokenType, action: "event", eventParams: s };
          n.postMessage(r, "*");
        } else if (i && i.error) {
          if ("string" == typeof i.error) throw new Error(i.error);
          if ("string" == typeof i.error.message)
            throw new Error(i.error.message);
          throw (
            (p("Event error", {
              error: i.error,
              request: t.eventParams.client,
            }),
            new Error("Event error occurred, check the logs"))
          );
        }
      },
      validateEvent: function (e, t) {
        if (!e || !c[e]) throw new Error("Invalid caller");
        if (!t || !t.tokenType)
          throw new Error("Invalid request, tokenType is required");
        if (!t.eventParams || !t.eventParams.client)
          throw new Error("Invalid request, parameters are missing");
        const n = this.getEventOwner(e, t.tokenType);
        if (!n || !n.events) throw new Error("Invalid event owner");
        if (!n.events[t.eventParams.client.eventName])
          throw new Error("Invalid event name");
      },
      getEventOwner: function (e, t) {
        switch (e) {
          case c.client:
            switch (t) {
              case o:
                return window.ckApplePay;
              case l:
                return window.ckGooglePay;
              case a:
                return window.ckCustomerAgreement;
            }
            break;
          case c.server:
            switch (t) {
              case o:
                return window.applePaySdk;
              case l:
                return window.googlePaySdk;
              case a:
                return window.custAgreement;
            }
        }
      },
      executeEventHandler: async function (e, t) {
        const n = function (e, t) {
          if ("function" == typeof e) return Array.isArray(t) ? e(...t) : e(t);
        };
        let i;
        switch (t.eventType) {
          case "success":
            i = n(e[`${t.eventName}-resolve`], t.eventArgs);
            break;
          case "reject":
            i = n(e[`${t.eventName}-reject`], t.eventArgs);
            break;
          case "function":
            i = n(e.events[t.eventName], t.eventArgs);
            break;
          case "function-promise":
            try {
              (i = n(e.events[t.eventName], t.eventArgs)),
                i instanceof Promise && (i = await i),
                (i = n(e[`${t.eventName}-resolve`], i));
            } catch (a) {
              i = n(e[`${t.eventName}-reject`], i);
            }
        }
        return i instanceof Promise && (i = await i), i;
      },
      buildEvent: function (e, t, n, i, a, o) {
        return new Promise((s, r) => {
          try {
            (e[n + "-resolve"] = s), (e[n + "-reject"] = r);
            const d = { eventType: "function", eventName: n, eventArgs: i },
              l = { eventType: a || "promise", eventName: n };
            this.submitEvent(t, { client: d, server: l }, o);
          } catch (e) {
            throw (p("buildEvent", e), e);
          }
        });
      },
      submitEvent: function (e, t, n) {
        const i = Object.assign(
          {},
          { action: "event", tokenType: e },
          { eventParams: t },
        );
        (n = (n && n.contentWindow) || window.parent).postMessage(i, "*");
      },
      submitLocalEvent: async function (e, t, n) {
        try {
          const i = { eventType: "function", eventName: t, eventArgs: n };
          return await v.executeEventHandler(e, i);
        } catch (e) {
          throw (p("submitLocalEvent", e), e);
        }
      },
    },
    w = {
      address_validation: 3,
      support_recurring: 13,
      support_subscription: 13,
    },
    b = {
      events: {},
      defPaymentRequest: {
        buttonOptions: {
          buttonContainer: null,
          buttonColor: s.black,
          buttonType: r.pay,
          activeButtonColor: null,
          width: null,
          height: null,
          minWidth: null,
          minHeight: null,
        },
        walletCheckEnabled: !1,
        applicationData: null,
        merchantIdentifier: null,
        merchantCapabilities: ["supports3DS"],
        supportedNetworks: ["amex", "discover", "masterCard", "visa"],
        supportedCountries: [],
        countryCode: "US",
        currencyCode: "USD",
        requiredFeatures: [],
        requiredBillingContactFields: ["postalAddress", "name"],
        billingContact: void 0,
        shippingContact: void 0,
        shippingType: null,
        shippingMethods: [],
        total: null,
        lineItems: null,
        setShippingMethods: function (e) {
          this.shippingMethods = e;
        },
        isFeatureRequested: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          return t.some((e) => this.requiredFeatures.includes(e));
        },
        validateFeatures: function (e) {
          if (e) {
            if (e.error && !this.isFeatureRequested(d.address_validation))
              throw "Error. A Required Feature 'address_validation' must be set. Please refer to documentation on how to set 'requiredFeatures' for Address Validation";
            if (
              e.lineItems &&
              !this.isFeatureRequested(
                d.support_recurring,
                d.support_subscription,
              ) &&
              e.lineItems.some(
                (e) =>
                  e.paymentTiming ||
                  e.recurringPaymentStartDate ||
                  e.recurringPaymentIntervalUnit ||
                  e.recurringPaymentIntervalCount ||
                  e.deferredPaymentDate ||
                  e.automaticReloadPaymentThresholdAmount,
              )
            )
              throw "Error. A Required Feature 'support_recurring' or 'support_subscription' must be set. Please refer to documentation on how to set 'requiredFeatures' for Recurring/Subscription";
          }
        },
      },
      sessionCallbacks: {
        getApplePayError: function (e) {
          if (e) {
            if (!e.code)
              throw "'error.code' is required. For available codes refer to 'APErrorCode'";
            return (
              p("ApplePayError custom error", e),
              new ApplePayError(e.code, e.contactField, e.message)
            );
          }
          return null;
        },
        onCancel: async function (e) {
          const t = b;
          p("Apple Pay Session canceled", e),
            t.defPaymentRequest.onCancel &&
              (await v.submitLocalEvent(t.eventOwner, "onCancel", e));
        },
        onValidateMerchant: async function (e) {
          const t = b;
          try {
            e.isTrusted ||
              (p("onValidateMerchant", "Not trusted"), t.session.abort());
            const n = await v.submitLocalEvent(
                t.eventOwner,
                "onValidateMerchant",
                e.validationURL,
              ),
              i = JSON.parse(n);
            t.session.completeMerchantValidation(i);
          } catch (e) {
            p("onValidateMerchant error", e), t.onError(e);
          }
        },
        onPaymentAuthorize: async function (e) {
          const t = b;
          try {
            e.isTrusted ||
              (p("onPaymentAuthorize", "Not trusted"), t.session.abort());
            const n = await v.submitLocalEvent(
              t.eventOwner,
              "onPaymentAuthorize",
              e.payment,
            );
            t.session.completePayment(ApplePaySession.STATUS_SUCCESS),
              t.defPaymentRequest.onPaymentComplete &&
                v.submitLocalEvent(t.eventOwner, "onPaymentComplete", {
                  response: n,
                });
          } catch (e) {
            p("onPaymentAuthorize error", e),
              t.session.abort(),
              t.defPaymentRequest.onPaymentComplete &&
                v.submitLocalEvent(t.eventOwner, "onPaymentComplete", {
                  error: e,
                }),
              t.onError(e);
          }
        },
        onShippingContactSelected: async function (e) {
          const t = b;
          try {
            e.isTrusted ||
              (p("onShippingContactSelected", "Not trusted"),
              t.session.abort());
            const n = await v.submitLocalEvent(
              t.eventOwner,
              "onShippingContactSelected",
              e.shippingContact,
            );
            if (
              (t.defPaymentRequest.validateFeatures.call(
                t.defPaymentRequest,
                n,
              ),
              t.defPaymentRequest.version >= 3)
            ) {
              const e = {
                  newTotal: n.total,
                  newLineItems: n.lineItems,
                  newShippingMethods: n.shippingMethods,
                },
                i = t.sessionCallbacks.getApplePayError(n.error);
              i && (e.errors = [i]),
                t.session.completeShippingContactSelection(e);
            } else
              t.session.completeShippingContactSelection(
                ApplePaySession.STATUS_SUCCESS,
                n.shippingMethods,
                n.total,
                n.lineItems,
              );
          } catch (e) {
            p("onShippingContactSelected error", e), t.onError(e);
          }
        },
        onShippingMethodSelected: async function (e) {
          const t = b;
          try {
            e.isTrusted ||
              (p("onShippingMethodSelected", "Not trusted"), t.session.abort());
            const n = await v.submitLocalEvent(
              t.eventOwner,
              "onShippingMethodSelected",
              e.shippingMethod,
            );
            if (
              (t.defPaymentRequest.validateFeatures.call(
                t.defPaymentRequest,
                n,
              ),
              t.defPaymentRequest.version >= 3)
            ) {
              const e = { newTotal: n.total, newLineItems: n.lineItems };
              t.defPaymentRequest.version >= 13 &&
                n.shippingMethods &&
                (e.newShippingMethods = n.shippingMethods),
                t.session.completeShippingMethodSelection(e);
            } else
              t.session.completeShippingMethodSelection(
                ApplePaySession.STATUS_SUCCESS,
                n.total,
                n.lineItems,
              );
          } catch (e) {
            p("onShippingMethodSelected error", e), t.onError(e);
          }
        },
        onPaymentMethodSelected: async function (e) {
          const t = b;
          try {
            e.isTrusted ||
              (p("onPaymentMethodSelected", "Not trusted"), t.session.abort());
            const n = await v.submitLocalEvent(
              t.eventOwner,
              "onPaymentMethodSelected",
              e.paymentMethod,
            );
            if (
              (t.defPaymentRequest.validateFeatures.call(
                t.defPaymentRequest,
                n,
              ),
              t.defPaymentRequest.version >= 3)
            ) {
              const e = { newTotal: n.total, newLineItems: n.lineItems };
              if (t.defPaymentRequest.version >= 13) {
                n.shippingMethods && (e.newShippingMethods = n.shippingMethods);
                const i = t.sessionCallbacks.getApplePayError(n.error);
                i && (n.errors = [i]);
              }
              t.session.completePaymentMethodSelection(e);
            } else
              t.session.completePaymentMethodSelection(n.total, n.lineItems);
          } catch (e) {
            p("onPaymentMethodSelected error", e), t.onError(e);
          }
        },
      },
      onError: async function (e) {
        const t = b;
        try {
          t.defPaymentRequest.onError &&
            (await v.submitLocalEvent(t.eventOwner, "onError", e));
        } catch (e) {
          p("onSessionError error", e);
        }
        t.session && t.session.abort();
      },
      onBeforeProcessPayment: async function () {
        try {
          const e = b;
          if (e.defPaymentRequest.onBeforeProcessPayment) {
            const t = await v.submitLocalEvent(
              e.eventOwner,
              "onBeforeProcessPayment",
            );
            if (t !== i.success) throw t;
          }
          return i.success;
        } catch (e) {
          throw e;
        }
      },
      init: function (e) {
        try {
          (this.isDebug = e.isDebug),
            (() => {
              if (!window.ApplePaySession || !ApplePaySession.canMakePayments())
                throw "Apple Pay not supported";
              if (!e)
                throw "paymentRequest parameter is required. For more information please refer to documentation";
              if (!e.buttonOptions || !e.buttonOptions.buttonContainer)
                throw "paymentRequest.buttonOptions.buttonContainer is required. Must be an id of div element where Apple Pay button will be loaded";
            })(),
            (this.events.onTransactionInfo =
              this.setTransactionInfo.bind(this)),
            Object.assign(this.defPaymentRequest, e);
          const t = (() => {
              let e,
                t = 1,
                n = 100;
              for (; n - t > 1; )
                (e = h((n + t) / 2, 0)),
                  ApplePaySession.supportsVersion(e) ? (t = e) : (n = e);
              return t;
            })(),
            n = (() => {
              if (!e.requiredFeatures) return 1;
              const t = e.requiredFeatures.map((e) => w[e]),
                n = Math.max(...t);
              return !n || n < 1 ? 1 : n;
            })();
          if (
            (u(
              `minRequiredVersion: ${n}; supportedVersion: ${t}`,
              this.isDebug,
            ),
            t < n)
          )
            throw "Minimum Apple Pay required version is not supported by this device.\nPlease upgrade your iOS version.";
          (this.eventOwner = v.getEventOwner(c.client, o)),
            (this.defPaymentRequest.version = t),
            v
              .submitLocalEvent(this.eventOwner, "onGetTransactionInfo")
              .then((e) => {
                this.setTransactionInfo(e);
              })
              .catch((e) => {
                p("onGetTransactionInfo error", e);
              }),
            this.defPaymentRequest.onGetShippingMethods &&
              v
                .submitLocalEvent(this.eventOwner, "onGetShippingMethods")
                .then((e) => {
                  this.defPaymentRequest.setShippingMethods(e);
                })
                .catch((e) => {
                  p("onGetShippingMethods error", e);
                }),
            this.defPaymentRequest.walletCheckEnabled
              ? ApplePaySession.canMakePaymentsWithActiveCard(
                  this.defPaymentRequest.merchantIdentifier,
                )
                  .then((e) => {
                    if (!e) throw "Apple Pay not supported";
                    this.showApplePayButton(),
                      this.defPaymentRequest.onAPButtonLoaded &&
                        v.submitLocalEvent(
                          this.eventOwner,
                          "onAPButtonLoaded",
                          { status: i.success },
                        );
                  })
                  .catch((e) => {
                    throw e;
                  })
              : setTimeout(() => {
                  this.showApplePayButton(),
                    this.defPaymentRequest.onAPButtonLoaded &&
                      v.submitLocalEvent(this.eventOwner, "onAPButtonLoaded", {
                        status: i.success,
                      });
                }, 10);
        } catch (e) {
          if (
            (p("Apple Pay initialization failed", e),
            this.defPaymentRequest.onAPButtonLoaded)
          ) {
            const t = /not supported/i.test(e)
              ? { status: i.unsupported }
              : {
                  status: i.error,
                  reason:
                    "Failed to initialize Apple Pay. Please check the logs",
                };
            v.submitLocalEvent(this.eventOwner, "onAPButtonLoaded", t);
          }
        }
      },
      setTransactionInfo: function (e) {
        e &&
          (this.defPaymentRequest.validateFeatures.call(
            this.defPaymentRequest,
            e,
          ),
          (this.defPaymentRequest.total = e.total),
          (this.defPaymentRequest.lineItems = e.lineItems));
      },
      getPaymentRequest: function () {
        return {
          merchantCapabilities: this.defPaymentRequest.merchantCapabilities,
          supportedNetworks: this.defPaymentRequest.supportedNetworks,
          supportedCountries: this.defPaymentRequest.supportedCountries,
          countryCode: this.defPaymentRequest.countryCode,
          currencyCode: this.defPaymentRequest.currencyCode,
          requiredBillingContactFields:
            this.defPaymentRequest.requiredBillingContactFields,
          billingContact: this.defPaymentRequest.billingContact,
          requiredShippingContactFields:
            this.defPaymentRequest.requiredShippingContactFields,
          shippingContact: this.defPaymentRequest.shippingContact,
          shippingMethods: this.defPaymentRequest.shippingMethods,
          total: this.defPaymentRequest.total,
          lineItems: this.defPaymentRequest.lineItems,
        };
      },
      createSession: function () {
        const e = this.getPaymentRequest();
        return (
          (this.session = new ApplePaySession(
            this.defPaymentRequest.version,
            e,
          )),
          (this.session.merchantIdentifier =
            this.defPaymentRequest.merchantIdentifier),
          (this.session.oncancel = this.sessionCallbacks.onCancel),
          this.defPaymentRequest.onValidateMerchant &&
            (this.session.onvalidatemerchant =
              this.sessionCallbacks.onValidateMerchant),
          this.defPaymentRequest.onPaymentAuthorize &&
            (this.session.onpaymentauthorized =
              this.sessionCallbacks.onPaymentAuthorize),
          this.defPaymentRequest.onShippingContactSelected &&
            (this.session.onshippingcontactselected =
              this.sessionCallbacks.onShippingContactSelected),
          this.defPaymentRequest.onShippingMethodSelected &&
            (this.session.onshippingmethodselected =
              this.sessionCallbacks.onShippingMethodSelected),
          this.defPaymentRequest.onPaymentMethodSelected &&
            (this.session.onpaymentmethodselected =
              this.sessionCallbacks.onPaymentMethodSelected),
          this.session
        );
      },
      showApplePayButton: function () {
        HTMLCollection.prototype[Symbol.iterator] =
          Array.prototype[Symbol.iterator];
        const e = [
          ".apple-pay-button.visible { ",
          "visibility: visible; ",
          "} ",
          ".apple-pay-button:active { ",
          "background-color: " +
            this.defPaymentRequest.buttonOptions.activeButtonColor || 0,
          "}",
          ".apple-pay-button { ",
          "visibility: hidden;",
          "cursor: pointer;",
          "-webkit-appearance: -apple-pay-button;",
          "-apple-pay-button-type: " +
            (this.defPaymentRequest.buttonOptions.buttonType || r.pay) +
            ";",
          "-apple-pay-button-style: " +
            (this.defPaymentRequest.buttonOptions.buttonColor || s.black) +
            ";",
        ];
        this.defPaymentRequest.buttonOptions.minWidth &&
          e.push(
            "min-width: " +
              this.defPaymentRequest.buttonOptions.minWidth +
              "px;",
          ),
          this.defPaymentRequest.buttonOptions.minHeight &&
            e.push(
              "min-height: " +
                this.defPaymentRequest.buttonOptions.minHeight +
                "px;",
            ),
          this.defPaymentRequest.buttonOptions.width &&
            e.push(
              "width: " + this.defPaymentRequest.buttonOptions.width + ";",
            ),
          this.defPaymentRequest.buttonOptions.height &&
            e.push(
              "height: " + this.defPaymentRequest.buttonOptions.height + ";",
            ),
          e.push("}");
        const t = e.join("\n"),
          n = this.defPaymentRequest.buttonOptions.buttonContainer,
          i = "string" == typeof n ? document.getElementById(n) : n;
        if (!i)
          throw "Invalid buttonContainer. Must be an id of div element or element itself where Apple Pay button will be loaded";
        const a = document.head || document.getElementsByTagName("head")[0],
          o = document.createElement("style");
        a.appendChild(o),
          o.styleSheet
            ? (o.styleSheet.cssText = t)
            : o.appendChild(document.createTextNode(t)),
          (i.className += " apple-pay-button"),
          (i.className += " visible"),
          i.addEventListener("click", this.payButtonClicked);
      },
      payButtonClicked: async function (e) {
        const t = b;
        try {
          const e = t.createSession.call(t),
            n = await t.onBeforeProcessPayment();
          if (n !== i.success) throw n;
          e.begin();
        } catch (e) {
          p("Apple Pay session error", e), t.sessionCallbacks.onError(e);
        }
      },
    },
    C = { sandbox: 0, production: 1 },
    P = {
      iframe: "iframe",
      window: "window",
      isValid: function (e) {
        return e === this.iframe || e === this.window;
      },
    },
    E = {
      sdkSettings: {
        urls: [
          "https://sandbox.secure.checkout.visa.com/checkout-widget/resources/js/integration/v1/sdk.js",
          "https://secure.checkout.visa.com/checkout-widget/resources/js/integration/v1/sdk.js",
        ],
        assets: [
          "https://sandbox-assets.secure.checkout.visa.com/wallet-services-web/xo/button.png",
          "https://assets.secure.checkout.visa.com/wallet-services-web/xo/button.png",
        ],
        apiKeys: ["B0M69G64XJA427VYVR9D21LREy95j7ZjigC1LjlMb6VNVJjnI"],
        encryptionKeys: ["X1EMH2Z1WAY3G2AC50EJ13uIfP5GhdOFH1owxti6T0x2BXcX8"],
        sandboxExternalClientId: "test1",
        settings: {
          locale: "en_US",
          countryCode: "US",
          displayName: "Cardknox",
          acceptedRegions: "US",
          dataLevel: "FULL",
          payment: {
            cardBrands: ["VISA", "MASTERCARD", "AMEX", "DISCOVER"],
            billingCountries: ["US", "CA"],
          },
          review: {
            message: "Please confirm your payment",
            buttonAction: "PAY",
          },
          shipping: { acceptedRegions: ["US", "CA"], collectShipping: "true" },
          tokenizationSetup: {
            enableTokenization: !0,
            tokenCryptogramType: "TAVV",
          },
        },
      },
      imageBaseUri: "https://cdn.cardknox.com/ifields/images/c2p/",
      cardContainerType: P.iframe,
      forceClickToPayButton: !1,
      setConfiguration: function (e) {
        (this.environment = e.environment),
          (this.apiKey = this.sdkSettings.apiKeys[this.environment]),
          (this.encryptionKey =
            this.sdkSettings.encryptionKeys[this.environment]),
          (this.c2pBtnImg =
            this.sdkSettings.assets[this.environment] +
            "?cardBrands=VISA,MASTERCARD,DISCOVER,AMEX"),
          (this.cardContainerType = e.cardContainerType || P.iframe),
          (this.click2payContainer = e.click2payContainer),
          (this.mainCssClass = e.mainCssClass || "c2p-def"),
          (this.forceClickToPayButton = e.forceClickToPayButton),
          (this.displayWaitScreenAfterCheckout =
            !g(e.displayWaitScreenAfterCheckout) ||
            e.displayWaitScreenAfterCheckout),
          (this.externalClientId = e.externalClientId),
          (this.isDebug = e.isDebug || this.environment == C.sandbox),
          e.reviewAction &&
            (this.sdkSettings.settings.review.buttonAction = e.reviewAction);
      },
      logDebug: function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        this.isDebug && console.log.apply(console.log, t);
      },
      convertEnvironment: function (e) {
        if ("string" == typeof e) {
          const t = Object.keys(C).find((t) => e === t);
          if (t) return C[t];
        }
        return e;
      },
    },
    S = {
      currDate: (() => {
        const e = new Date();
        return Number(
          `${e.getFullYear()}${("0" + (e.getMonth() + 1)).slice(-2)}`,
        );
      })(),
      getConsumerIdentity: function (e, t) {
        return {
          identityProvider: "SRC",
          identityValue: e,
          type: (function () {
            if (!t) {
              if (!/\w+@\w+/.test(e))
                throw "Invalid identityValue and identityType";
              t = "EMAIL";
            }
            if (((t = t.toUpperCase()), ["EMAIL", "EMAIL_ADDRESS"].includes(t)))
              return "EMAIL";
            throw "Invalid identityType, only 'EMAIL' is valid";
          })(),
        };
      },
      getError: function (e) {
        let t = "";
        return (
          e.name && (t += `name:'${e.name}';`),
          e.reason && (t += `reason:'${e.status}';`),
          e.err && e.err.message && (t += `errMsg:'${e.err.message}'`),
          t
        );
      },
      getCardType: function (e) {
        return /^4/.test(e)
          ? "visa"
          : /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
                e,
              )
            ? "mc"
            : /^3[47]/.test(e)
              ? "amex"
              : null;
      },
      getCardBrandByCardType: function (e) {
        const t = this.getCardType(e);
        if (!t) throw "This Card Brand is not supported";
        return t;
      },
      validateCardData: function (e) {
        return (
          e &&
            e.panExpirationYear &&
            e.panExpirationYear.length < 4 &&
            (e.panExpirationYear = "20" + e.panExpirationYear.substr(-2)),
          e
        );
      },
      validateEmail: function (e) {
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          e,
        );
      },
      isFunction: function (e) {
        return "function" == typeof e;
      },
      configureCardContainer: function (e) {
        return (
          e && E.cardContainerType === P.iframe && (e = e.contentWindow), e
        );
      },
      isiframeSupported: function () {
        return !/apple/i.test(navigator.vendor);
      },
      getCardContainer: function (e) {
        if ("VISA" === e) return null;
        let t = null;
        return (
          this.isiframeSupported || (E.cardContainerType = P.window),
          E.cardContainerType === P.iframe &&
            ((t = document.getElementById("cardContainer")), (t.style = "")),
          t
            ? t.contentWindow
            : window.open(
                "about:blank",
                "dcf",
                "width=430, height=760, location=no",
              )
        );
      },
      closeCardContainer: function (e) {
        if (e)
          if (E.cardContainerType === P.iframe) {
            const e = document.getElementById("cardContainer");
            (e.style = "display:none"), (e.src = "about:blank");
          } else e.close();
      },
      isCardExpired: function (e) {
        return (
          "EXPIRED" === e.digitalCardData.status ||
          Number(e.panExpirationYear + e.panExpirationMonth) < this.currDate
        );
      },
      sortCards: function (e, t) {
        return e.expired && !t.expired
          ? 1
          : !e.expired && t.expired
            ? -1
            : t.index - e.index;
      },
      buildProfilesScreen: async function (e, t, n) {
        if (!e || !e.maskedCards) return null;
        let i = [],
          a = 0;
        if (
          (e.maskedCards.forEach((e) => {
            try {
              E.logDebug("card:", JSON.stringify(e));
              const t = new Promise((t, i) => {
                try {
                  if (
                    "ACTIVE" === e.digitalCardData.status ||
                    "EXPIRED" === e.digitalCardData.status
                  ) {
                    const i = document.createElement("tr");
                    (i.className = "c2p-card-row"),
                      i.addEventListener("click", async () => {
                        n({
                          cardId: e.srcDigitalCardId,
                          cardNetwork: e.network,
                        });
                      }),
                      i
                        .addComponent("td", { class: "c2p-card" })
                        .addComponent("img", {
                          src: `${e.digitalCardData.artUri}`,
                          class: "c2p-card-img",
                        }),
                      i
                        .addComponent("td", { class: "c2p-brand" })
                        .addComponent("img", S.getCardBrandImage(e.network)),
                      i
                        .addComponent("td", { class: "c2p-card-number" })
                        .addComponent("span", {
                          class: "c2p-card-txt",
                          innerHTML: `${e.digitalCardData.presentationName || ""}****${e.panLastFour}`,
                        });
                    const a = i.addComponent("td", {
                        class: "c2p-card-expired",
                      }),
                      o = this.isCardExpired(e);
                    o && a.addComponent("span", { innerHTML: "expired" }),
                      i
                        .addComponent("td", { class: "c2p-card-arrow" })
                        .addComponent("img", {
                          src: E.imageBaseUri + "arrow.png",
                        }),
                      t({
                        index: this.maxDate(
                          e.dateOfCardLastUsed,
                          e.dateOfCardCreated,
                        ),
                        expired: o,
                        payload: i,
                      });
                  }
                } catch (n) {
                  logError(`Error for ${e.panLastFour}`, n),
                    t({ index: a++, payload: null });
                }
              });
              i.push(t);
            } catch (e) {
              logError("Error loading profile", e);
            }
          }),
          i.length > 0)
        ) {
          const e = t.addComponent("div", { class: "c2p-form" });
          e.addComponent("div", { class: "c2p-header" }).addComponent("img", {
            src: E.imageBaseUri + "c2p-cards.png",
          });
          const n = e.addComponent("div"),
            a = this.buildComponent("table", n, {
              id: "profilesTable",
              class: "c2p-table-card",
            }),
            o = await Promise.all(i);
          return (
            o &&
              o.length > 0 &&
              (o.sort((e, t) => this.sortCards(e, t)),
              o.forEach((e) => {
                e.payload && a.appendChild(e.payload);
              })),
            a
          );
        }
        return null;
      },
      getCardBrandImage: function (e) {
        switch (e.toUpperCase()) {
          case "VISA":
            return {
              src: E.imageBaseUri + "c2p-visa-icon.png",
              class: "c2p-visa-icon-img",
            };
          case "MASTERCARD":
            return {
              src: E.imageBaseUri + "c2p-mc-icon.png",
              class: "c2p-mc-icon-img",
            };
          case "DISCOVER":
            return {
              src: E.imageBaseUri + "c2p-discover-icon.png",
              class: "c2p-discover-icon-img",
            };
          default:
            return {
              src: E.imageBaseUri + "c2p-amex-icon.png",
              class: "c2p-amex-icon-img",
            };
        }
      },
      buildNoProfilesScreen: function (e) {
        const t = e.addComponent("div", { class: "c2p-form" });
        t.addComponent("div", { class: "c2p-header" }).addComponent("img", {
          src: E.imageBaseUri + "c2p-cards.png",
        });
        const n = t.addComponent("div", { class: "c2p-no-profiles" });
        n.addComponent("span", { innerHTML: "No cards found" }),
          n
            .addComponent("a", { href: "#", innerHTML: "Use different login" })
            .addEventListener("click", async () => {
              click2pay.resetScreen.call(click2pay, !0, !0);
            });
      },
      buildWaitScreen: function () {
        let e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        return new Promise((t, n) => {
          setTimeout(() => {
            try {
              const n = this.getElement(e && e.parent) || E.click2payContainer,
                i = S.buildComponent("div", n, {
                  id: "waitDivId",
                  class: E.mainCssClass,
                });
              if (e && g(e.showHeader) && !e.showHeader)
                i.addWaitComponent(e && e.imgWidth, e && e.imgHeight);
              else {
                const t = i.addComponent("div", {
                  class: "c2p-form",
                  style: "height:100px; display:inline-block",
                });
                t
                  .addComponent("div", { class: "c2p-header" })
                  .addComponent("img", {
                    src: E.imageBaseUri + "c2p-cards.png",
                  }),
                  t.addWaitComponent(e && e.imgWidth, e && e.imgHeight);
              }
              t(i);
            } catch (e) {
              n(e);
            }
          }, 1);
        });
      },
      buildSignInScreen: function (e, t) {
        const n = () => {
            if (this.signinSubmitted) return;
            this.signinSubmitted = !0;
            const e = a.addWaitComponent();
            setTimeout(() => {
              try {
                i()
                  ? t(i())
                  : ((this.signinSubmitted = !1), this.removeComponent(e));
              } catch (t) {
                (this.signinSubmitted = !1), this.removeComponent(e);
              }
            }, 1);
          },
          i = () => {
            const e = document.getElementById("txtEmail"),
              t = document.getElementById("lblEmail"),
              n = document.getElementById("lblError");
            return this.validateEmail(e.value)
              ? ((n.innerHTML = ""),
                t.classList.remove("invalid"),
                e.classList.remove("invalid"),
                this.getConsumerIdentity(e.value, "EMAIL"))
              : (E.logDebug("invalid email"),
                (n.innerHTML = e.value ? "Invalid Email" : ""),
                t.classList.add("invalid"),
                e.classList.add("invalid"),
                null);
          };
        this.signinSubmitted = !1;
        const a = e.addComponent("div", { class: "c2p-form" });
        a.addComponent("div", { class: "c2p-header" }).addComponent("img", {
          src: E.imageBaseUri + "c2p-cards.png",
        });
        const o = a
          .addComponent("div", { class: "c2p-body" })
          .addComponent("div", { class: "inputs" });
        o.addComponent("div", {
          class: "body-text",
          innerHTML: "Enter email to access your cards<br />",
        });
        const s = o.addComponent("div", { class: "div-signin" });
        s.addComponent("label", {
          id: "lblEmail",
          for: "txtEmail",
          class: "lbl-signin",
          innerHTML: "Email",
        });
        const r = s.addComponent("input", {
          type: "email",
          id: "txtEmail",
          class: "txt-signin",
          autocomplete: "on",
        });
        r.addEventListener("keypress", (e) => {
          S.handleDefaultButton(e, "c2pValidateButton");
        }),
          s.addComponent("label", { id: "lblError", class: "error-label" }),
          s
            .addComponent("a", {
              id: "c2pValidateButton",
              class: "c2p-btn",
              innerHTML: "Continue",
            })
            .addEventListener("click", () => n()),
          setTimeout(() => {
            r.focus();
          }, 10);
      },
      buildOtpScreen: function (e, t, n, i) {
        let a = 1;
        const o = () => {
            const e = d.addWaitComponent();
            setTimeout(async () => {
              try {
                if (
                  (() => {
                    try {
                      let e = !0;
                      if (
                        (document.getElementsByName("txtOtp").forEach((t) => {
                          t.value
                            ? t.classList.remove("invalid")
                            : (t.classList.add("invalid"), (e = !1));
                        }),
                        !e)
                      )
                        throw "Invalid OTP";
                      return !0;
                    } catch (e) {
                      return !1;
                    }
                  })()
                ) {
                  const e = await t(
                    (function () {
                      let e = "";
                      return (
                        document
                          .getElementsByName("txtOtp")
                          .forEach((t) => (e += t.value)),
                        e
                      );
                    })(),
                    a,
                  );
                  E.logDebug(e);
                } else this.removeComponent(e);
              } catch (t) {
                (document.getElementById("lblOtpError").innerHTML = t),
                  this.removeComponent(e),
                  a++;
              }
            }, 1);
          },
          s = async () => {
            const e = d.addWaitComponent();
            setTimeout(async () => {
              try {
                r(), (document.getElementById("lblOtpError").innerHTML = "");
                const e = await i(n);
                E.logDebug(e);
              } catch (e) {
                document.getElementById("lblOtpError").innerHTML = e;
              } finally {
                this.removeComponent(e);
              }
            }, 1);
          },
          r = () => {
            const e = document
              .getElementById("divOtp")
              .getElementsByTagName("input");
            for (let t = 0; t < e.length; t++) e[t].value = "";
            e[0].focus();
          },
          d = e.addComponent("div", { class: "c2p-form" });
        d.addComponent("div", { class: "c2p-header" }).addComponent("img", {
          src: E.imageBaseUri + "c2p-cards.png",
        });
        const l = d
          .addComponent("div", { class: "c2p-body" })
          .addComponent("div", { class: "inputs" });
        l.addComponent("label", {
          class: "lbl-txt-otp",
          for: "txtOtp",
          innerHTML: "One-time code",
        }),
          l.addComponent("br"),
          l
            .addComponent("div", { id: "divOtp", class: "container-txt-otp" })
            .addOtpInputComponent(
              6,
              {
                name: "txtOtp",
                class: "txt-otp",
                maxlength: 1,
                size: 1,
                pattern: "[0-9]{1}",
              },
              "c2pOtpButton",
              "lblOtpError",
            );
        const c = l.addComponent("div", { class: "resend-otp" });
        c.addComponent("span", { innerHTML: "Didn't receive the code?" }),
          c
            .addComponent("a", {
              class: "resend-otp-btn",
              href: "#",
              innerHTML: "Resend Now",
            })
            .addEventListener("click", () => s()),
          l.addComponent("label", { id: "lblOtpError", class: "error-label" }),
          l
            .addComponent("a", {
              id: "c2pOtpButton",
              class: "c2p-btn",
              innerHTML: "Continue",
            })
            .addEventListener("click", () => o());
      },
      getElement: function (e) {
        return (
          "string" == typeof e && (e = document.getElementById(e)),
          e && e.appendChild ? e : null
        );
      },
      buildComponent: function (e, t, n) {
        if (!n || !n.id) throw "'settings.id' is required to build component.";
        const i = document.getElementById(n.id);
        if (i) return i;
        if (!(t = this.getElement(t))) throw new Error("parent not found");
        return t.addComponent(e, n);
      },
      removeComponent: function (e) {
        "string" == typeof e && (e = document.getElementById(e)),
          e && e.parentElement && e.parentElement.removeChild(e);
      },
      handleDefaultButton: function (e, t) {
        if (13 === e.keyCode) {
          e.preventDefault(), e.stopPropagation();
          const n = document.getElementById(t);
          n && n.click();
        }
      },
      addCardContainer: function (e) {
        document.body.addComponent("iframe", {
          id: "cardContainer",
          sandbox:
            "allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-modals",
          role: "presentation",
          style: "display:none",
        });
      },
      maxDate(e, t) {
        const n = Date.parse(e),
          i = Date.parse(t);
        return n && i ? Math.max(n, i) : n || i;
      },
      valOrDef: function (e, t) {
        return e || t;
      },
      callServer: async function (e, t) {
        return new Promise(function (n, i) {
          var a = new XMLHttpRequest();
          a.open("POST", e),
            (a.onload = function () {
              this.status >= 200 && this.status < 300
                ? n(a.response)
                : i({ status: this.status, statusText: a.response });
            }),
            (a.onerror = function () {
              i({ status: this.status, statusText: a.statusText });
            }),
            t
              ? (a.setRequestHeader("Content-Type", "application/json"),
                a.send(JSON.stringify(t)))
              : a.send();
        });
      },
    };
  (HTMLElement.prototype.addComponent = function (e, t) {
    let n = document.createElement(e);
    return (
      t &&
        (t.innerHTML && ((n.innerHTML = t.innerHTML), delete t.innerHTML),
        Object.entries(t).forEach((e) => {
          let [t, i] = e;
          return n.setAttribute(t, i);
        })),
      this.appendChild(n)
    );
  }),
    (HTMLElement.prototype.addWaitComponent = function () {
      let e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
        t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      const n = this.addComponent("div", { class: "wait" });
      return (
        (e = e || 48),
        (t = t || 48),
        n.addComponent("img", {
          src: E.imageBaseUri + "wait.gif",
          style: `width:${e}px; height:${t}px;`,
        }),
        n
      );
    }),
    (HTMLElement.prototype.addOtpInputComponent = function (e, t, n, i) {
      const a = [];
      t.style = "color: transparent; text-shadow: 0 0 0 gray;";
      for (let n = 0; n < e; n++) {
        let e = this.addComponent("input", t);
        (e.dataIndex = n), a.push(e);
      }
      a[0].focus();
      const o = /\D/;
      for (let e = 0; e < a.length; e++)
        a[e].addEventListener("keydown", function (e) {
          let t = this.dataIndex;
          "Backspace" === e.key || "Delete" === e.key
            ? a[t].value
              ? (a[t].value = "")
              : t > 0 && a[t - 1].focus()
            : "ArrowLeft" === e.key && t > 0
              ? a[t - 1].focus()
              : "ArrowRight" === e.key && t < a.length
                ? a[t + 1].focus()
                : "Enter" === e.key && n
                  ? S.handleDefaultButton(e, n)
                  : 1 == e.key.length && (a[t].value = "");
        }),
          a[e].addEventListener("input", function () {
            const e = document.getElementById(i);
            e && (e.innerHTML = "");
            let t = this.dataIndex;
            if (
              (o.test(a[t].value) && (a[t].value = ""),
              t === a.length - 1 && a[t].value)
            )
              return !0;
            a[t].value && a[t + 1].focus();
          }),
          a[e].addEventListener("paste", function (e) {
            e.stopPropagation(), e.preventDefault();
            let t = e.clipboardData.getData("Text").trim();
            if (o.test(t)) a.forEach((e) => (e.value = ""));
            else {
              let e = t.split(""),
                n = 0;
              for (
                let t = this.dataIndex;
                t < Math.min(this.dataIndex + e.length, a.length);
                t++
              )
                (a[t].value = e[n]), n++, a[t].focus();
            }
          });
    });
  const I = {
      init: async function (e) {
        return new Promise((t, n) => {
          try {
            (this.initResolve = t),
              (this.initReject = n),
              (this.c2pCallbacks = {
                success: e.onPaymentSuccess,
                cancel: e.onPaymentCancel,
                error: e.onPaymentError,
                validate: e.onPaymentValidate,
                prefill: e.onPaymentPrefill,
              }),
              (window.onVisaCheckoutReady = this.initVisaSdk),
              S.buildComponent("script", document.body, {
                id: "visaSdkScript",
                src: E.sdkSettings.urls[E.environment],
                type: "text/javascript",
              });
          } catch (e) {
            logError("init failed", e), n({ message: "init failed", error: e });
          }
        });
      },
      getInitParameters: async function () {
        return {
          apikey: E.apiKey,
          encryptionKey: E.encryptionKey,
          externalClientId: E.externalClientId,
          settings: Object.assign({}, E.sdkSettings.settings),
          paymentRequest: await this.getPaymentRequest(),
        };
      },
      getPaymentRequest: async function () {
        if (!S.isFunction(this.c2pCallbacks.prefill))
          throw "onPaymentPrefill is required";
        const e = await Promise.resolve(this.c2pCallbacks.prefill());
        if (!e) throw "paymentRequest is required";
        return e;
      },
      initVisaSdk: async function (e) {
        try {
          const t = await I.getInitParameters.call(I),
            n = e ? window.V.init : window.V.initializeVsb,
            i = await n(t);
          if (
            (E.logDebug("initializeVsb result", JSON.stringify(i)),
            E.logDebug("Visa V:", JSON.stringify(V)),
            !(e || (i && i.isInitCompleted)))
          )
            throw { message: "initVisaSdk failed", result: i };
          I.initResolve &&
            (window.V.on("payment.success", (e) => {
              I.handleCallback.call(I, "success", e);
            }),
            window.V.on("payment.cancel", (e) => {
              I.handleCallback.call(I, "cancel", e);
            }),
            window.V.on("payment.error", (e, t) => {
              I.handleCallback.call(I, "error", e, t);
            }),
            window.V.on("pre-payment.user-data-prefill", () => {
              I.invokeCallback(I.c2pCallbacks.prefill);
            }),
            I.initResolve()),
            E.logDebug("Initialization succeeded");
        } catch (e) {
          logError("initVisaSdk failed", e), I.initReject && I.initReject(e);
        }
      },
      clearInitResponse: function () {
        (this.initResolve = void 0), (this.initReject = void 0);
      },
      handleCallback: function (e, t, n) {
        try {
          if (
            ("error" === e
              ? console.error(
                  "payment.error",
                  JSON.stringify(t),
                  JSON.stringify(n),
                )
              : E.logDebug("payment." + e, JSON.stringify(t)),
            !t)
          )
            throw "Invalid request";
          Array.isArray(t) && (t = t[0]);
          const i = t.dpaCheckoutResponse || t,
            a = i.vInitRequest.paymentRequest,
            o = {
              status: e,
              amount: a.total,
              merchantRequestId: a.merchantRequestId,
              merchantOrderId: a.orderId,
              payload: {
                transactionId: i.callid,
                externalClientId: i.vInitRequest.externalClientId,
                encryptionKey: i.encKey,
                token: i.encPaymentData,
              },
            };
          i.why && (o.reason = i.why),
            n && (o.error = n),
            this.invokeCallback(this.c2pCallbacks[e], o);
        } catch (e) {
          logError("Callback failed", e);
        }
      },
      invokeCallback: function (e) {
        for (
          var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1;
          i < t;
          i++
        )
          n[i - 1] = arguments[i];
        E.logDebug("args", n), "function" == typeof e && e.apply(e, n);
      },
      getRecognized: async function () {
        try {
          const e = await window.V.isRecognized();
          return (
            E.logDebug("IsRecoginized Response", JSON.stringify(e)),
            (this.idTokens = e.idTokens),
            (this.isRecognized = e.recognized),
            (this.usedDevice = e.usedDevice),
            E.logDebug("IsRecoginized: ", this.isRecognized),
            { isRecognized: this.isRecognized, usedDevice: this.usedDevice }
          );
        } catch (e) {
          return (
            logError("isRecognized failed", e),
            { isRecognized: !1, usedDevice: !1 }
          );
        }
      },
      validateConsumer: async function (e) {
        try {
          const t = await window.V.identityLookup(e);
          if (
            (E.logDebug("identityLookup", JSON.stringify(t)),
            !t || !t.consumerPresent)
          )
            throw (E.logDebug("validateConsumer failed", t), t);
          const n = await window.V.initiateIdentityValidation();
          return E.logDebug("initiateIdentityValidation", JSON.stringify(n)), n;
        } catch (e) {
          return logError("Error validating Customer", e), e;
        }
      },
      validateOtp: async function (e) {
        try {
          const t = await window.V.completeIdentityValidation({
            validationData: e,
          });
          if (
            (E.logDebug("validateOtp", JSON.stringify(t)),
            !t || !t.isValidationComplete)
          )
            throw "Consumer validation failed";
          return !0;
        } catch (e) {
          throw (logError("Error validating otp", e), e);
        }
      },
      getProfiles: async function () {
        try {
          const e = await window.V.getSrcProfile();
          return (
            (this.maskedCards = e.maskedCards),
            (this.profiles = e.profiles),
            { profiles: this.profiles, maskedCards: this.maskedCards }
          );
        } catch (e) {
          return logError("Error getting profiles", e), null;
        }
      },
      checkout: async function (e) {
        try {
          const t = {
            srcDigitalCardId: e.cardId,
            consumer: e.consumer,
            initializeVsbRequest: e.initParameters,
          };
          try {
            const e = await window.V.checkout(t);
            return (
              E.logDebug("checkout response", JSON.stringify(e)),
              e && e.dcfActionCode
                ? { action: e.dcfActionCode }
                : { action: "NONE" }
            );
          } finally {
          }
        } catch (e) {
          logError("Error while doing checkout", e);
        }
      },
      removeProfile: async function () {
        try {
          const e = await window.V.unbindAppInstance();
          return (
            S.clear(),
            E.logDebug("removeProfile", JSON.stringify(e, null, 2)),
            !0
          );
        } catch (e) {
          return logError("removeProfile", e), !1;
        }
      },
      uuid4: function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (e) {
            var t = (16 * Math.random()) | 0;
            return ("x" == e ? t : (3 & t) | 8).toString(16);
          },
        );
      },
    },
    k = {
      init: function (e) {
        setTimeout(async () => {
          let t = null,
            n = null;
          try {
            (e.environment = E.convertEnvironment(e.environment)),
              k.validateInit(e),
              E.logDebug("init:", e.environment),
              E.setConfiguration(e),
              (t = await S.buildWaitScreen(E.click2payContainer));
            let i = await I.init(e);
            (i = await k.initFlow.call(k, !1)),
              E.logDebug(i),
              (n = { status: iStatus.success });
          } catch (e) {
            throw (
              (logError("click2pay.init error: ", e),
              (n = {
                status: iStatus.error,
                reason: y(e, "Failed to load Click-To-Pay"),
              }),
              e)
            );
          } finally {
            if ((I.clearInitResponse(), e.onButtonLoaded))
              try {
                e.onButtonLoaded(n);
              } catch (e) {
                logError("click2pay.onButtonLoaded error: ", e);
              }
            t && S.removeComponent(t);
          }
        }, 1);
      },
      validateInit: function (e) {
        if (!e) throw "initArgs is required";
        if (!g(e.environment) || "" === e.environment)
          throw "initArgs.environment is required. Must be a valid c2pEnvironment value";
        if ("number" != typeof e.environment)
          throw "initArgs.environment must be a valid c2pEnvironment value";
        if (e.environment < 0 || e.environment >= E.sdkSettings.urls.length)
          throw "initArgs.environment is out of range. It must be a valid c2pEnvironment value";
        if (!e.externalClientId) throw "initArgs.externalClientId is required";
        if (!e.click2payContainer)
          throw "initArgs.click2payContainer is required";
        if (
          ((e.click2payContainer = document.getElementById(
            e.click2payContainer,
          )),
          !e.click2payContainer)
        )
          throw "initArgs.click2payContainer must be a valid ID of <div> element";
        if (e.cardContainerType && !P.isValid(e.cardContainerType))
          throw "initArgs.cardContainerType must be a valid c2pCardContainerType value";
        if (!e.onPaymentPrefill) throw "'onPaymentPrefill' is required";
        if (!S.isFunction(e.onPaymentPrefill))
          throw "'onPaymentPrefill' must be a function";
        if (e.onButtonLoaded && !S.isFunction(e.onButtonLoaded))
          throw "'onButtonLoaded' must be a function";
        if (e.onPaymentValidate && !S.isFunction(e.onPaymentValidate))
          throw "'onPaymentValidate' must be a function";
        if (e.onPaymentSuccess && !S.isFunction(e.onPaymentSuccess))
          throw "'onPaymentSuccess' must be a function";
        if (e.onPaymentCancel && !S.isFunction(e.onPaymentCancel))
          throw "'onPaymentCancel' must be a function";
        if (e.onPaymentError && !S.isFunction(e.onPaymentError))
          throw "'onPaymentError' must be a function";
        if (e.environment === c2pEnvironment.production && !e.externalClientId)
          throw "initArgs.externalClientId is required.";
      },
      initFlow: async function () {
        return new Promise((e, t) => {
          const n = async () => {
            let e = {};
            E.forceClickToPayButton || (e = await I.getRecognized()),
              e.isRecognized
                ? (this.mainDiv = await this.displayProfiles())
                : e.usedDevice
                  ? (this.mainDiv = this.buildSignInScreen())
                  : (this.mainDiv = this.displayNewUser());
          };
          try {
            const i = 150;
            let a = 0;
            const o = setInterval(async () => {
              try {
                if (
                  (a++,
                  E.logDebug("Loading SDK Counter: " + a),
                  a === i &&
                    (clearInterval(o), logError("Click-To-Pay Timed Out")),
                  window.V)
                ) {
                  clearInterval(o);
                  const t = await n();
                  e(t);
                }
              } catch (e) {
                logError("click2pay.initFlow error: ", e), t(e);
              }
            }, 100);
          } catch (e) {
            logError("click2pay.initFlow error: ", e), t(e);
          }
        });
      },
      buildSignInScreen: function () {
        const e = S.buildComponent("div", E.click2payContainer, {
          id: "divSignIn",
          class: E.mainCssClass,
        });
        return S.buildSignInScreen(e, this.validateConsumer), e;
      },
      validatePayment: async function (e) {
        try {
          if ((E.logDebug("validate payment:", e), 0 !== e.button)) return;
          if (S.isFunction(I.c2pCallbacks.validate)) {
            const e = await Promise.resolve(I.c2pCallbacks.validate());
            E.logDebug(e);
          }
          if (S.isFunction(I.c2pCallbacks.prefill)) {
            const e = await Promise.resolve(I.c2pCallbacks.prefill());
            if (e) {
              const t = await I.initVisaSdk(!0, e);
              E.logDebug(t);
            }
          }
        } catch (t) {
          logError("validatePayment", t),
            e.preventDefault(),
            e.stopPropagation();
        }
      },
      validateConsumer: async function (e) {
        const t = await I.validateConsumer(e);
        S.removeComponent(k.mainDiv),
          t && t.maskedValidationChannel
            ? ((k.mainDiv = S.buildComponent("div", E.click2payContainer, {
                id: "divOtp",
                class: E.mainCssClass,
              })),
              S.buildOtpScreen(k.mainDiv, k.validateOtp, e, I.validateConsumer))
            : (k.mainDiv = await k.displayNewUser());
      },
      validateOtp: async function (e, t) {
        try {
          (await I.validateOtp(e)) &&
            (k.mainDiv = await k.displayProfiles.call(k));
        } catch (e) {
          if (!(t >= 3)) throw e;
          setTimeout(() => {
            S.removeComponent(k.mainDiv), (k.mainDiv = k.buildSignInScreen());
          }, 10);
        }
      },
      displayNewUser: async function () {
        const e = S.buildComponent("div", E.click2payContainer, {
            id: "divNewUser",
            class: `${E.mainCssClass} datatooltip`,
            style: "display:none",
          }),
          t = e.addComponent("div", { class: "c2p-new-btn" });
        t.addEventListener(
          "click",
          (e) => {
            k.validatePayment(e).catch((e) =>
              logError("validatePayment error", e),
            );
          },
          !0,
        ),
          t.addComponent("img", {
            id: "c2pBtn",
            src: E.c2pBtnImg,
            class: "v-button c2p-new-btn",
            role: "button",
            alt: "Click-To-Pay",
          });
        const n = await I.initVisaSdk(!0);
        return E.logDebug(n), (e.style.display = ""), e;
      },
      displayProfiles: async function () {
        const e = await I.getProfiles();
        E.logDebug("displayProfiles - profileInfo:", JSON.stringify(e));
        const t = S.buildComponent("div", E.click2payContainer, {
          id: "divUserProfiles",
          class: E.mainCssClass,
          style: "display:none",
        });
        let n = null;
        return (
          e &&
            e.maskedCards &&
            (n = S.buildProfilesScreen(e, t, this.checkout)),
          n || S.buildNoProfilesScreen(t),
          S.removeComponent(k.mainDiv),
          (t.style = ""),
          t
        );
      },
      resetScreen: function (e, t) {
        E.logDebug(
          "resetScreen - mainDiv",
          this.mainDiv ? this.mainDiv.id : "null",
        ),
          S.removeComponent(this.mainDiv),
          setTimeout(async () => {
            let n = null;
            try {
              if ((t && (n = await S.buildWaitScreen(E.click2payContainer)), e))
                this.mainDiv = this.buildSignInScreen();
              else {
                const e = await this.initFlow();
                E.logDebug(e);
              }
            } finally {
              n && S.removeComponent(n);
            }
          }, 1);
      },
      checkout: async function (e) {
        if (S.isFunction(I.c2pCallbacks.validate)) {
          const e = await Promise.resolve(I.c2pCallbacks.validate());
          E.logDebug("checkout-validate", e);
        }
        e.initParameters = I.getInitParameters();
        try {
          const t = await I.checkout(e);
          E.logDebug(t);
        } finally {
          k.resetScreen.call(k, !1, E.displayWaitScreenAfterCheckout);
        }
      },
    },
    A = "card-number",
    T = "cvv",
    L = "card",
    x = "cvv",
    D = "ach",
    M = "ach",
    R = "card-data-error";
  var q = !1,
    F = !1,
    O = !1,
    B = !1,
    N = !1,
    G = !1,
    W = !1,
    H = !1,
    j = new Date(),
    z = {},
    U = "",
    J = "",
    K = "",
    _ = !1,
    X = !1,
    Y = "",
    Z = null,
    Q = {},
    ee = !1,
    te = " ";
  let ne = !1;
  var ie = {
    cardNumberIsValid: !1,
    cardNumberLength: 0,
    cardNumberFormattedLength: 0,
    cardNumberIsEmpty: !0,
    issuer: "unknown",
    cvvIsValid: !1,
    cvvLength: 0,
    cvvIsEmpty: !0,
    achLength: 0,
    achIsEmpty: !0,
    achIsValid: !1,
    lastIfieldChanged: "",
  };
  let ae = ["change", "blur", "keypress"];
  function oe(e, t) {
    return document.querySelector("[" + e + "='" + t + "']");
  }
  function se() {
    for (
      var e = document.getElementsByTagName("iframe"), t = 0;
      t < e.length;
      t++
    )
      /(ifield|igp|agreement)\.html?$/.test(e[t].src) &&
        e[t].contentWindow.postMessage({ action: "ping" }, "*");
  }
  function re(e, t, n, i) {
    e.source.postMessage(
      { action: "init", tokenType: n, referrer: window.location.toString() },
      "*",
    ),
      pe(t, i);
  }
  function de(e) {
    q && console.log(e);
  }
  function le(e) {
    return null != oe("data-ifields-id", e);
  }
  function ce(e, t) {
    z[e] = t;
    let n = 0;
    var i = setInterval(function () {
      if (
        le(e) &&
        ((e === A && F) ||
          (e === T && O) ||
          (e === D && B) ||
          (e === l && be.isFrameLoaded))
      ) {
        clearInterval(i);
        var a = { action: e === l ? "gp-style" : "style", data: t };
        de("Setting ifield style for iframe id " + e),
          oe("data-ifields-id", e).contentWindow.postMessage(a, "*");
      }
      (n += 1),
        n >= 50 &&
          (de("Setting ifield style for iframe id timed out"),
          clearInterval(i));
    }, 100);
  }
  function ue(e) {
    le(R) && (oe("data-ifields-id", R).innerHTML = e);
  }
  function pe(e, t) {
    var n = { action: "setPlaceholder", data: t };
    de("Setting ifield placeholder for iframe id " + e),
      oe("data-ifields-id", e).contentWindow.postMessage(n, "*");
  }
  function me(e, t, n) {
    (U = e), (J = t), (K = n);
    var i = {
      action: "setAccountData",
      data: { xKey: e, xSoftwareName: t, xSoftwareVersion: n },
    };
    if (le(A))
      var a = setInterval(function () {
        F &&
          (clearInterval(a),
          de("Setting ifield account data for iframe id " + A),
          oe("data-ifields-id", A).contentWindow.postMessage(i, "*"));
      }, 100);
    if (le(T))
      var o = setInterval(function () {
        O &&
          (clearInterval(o),
          de("Setting ifield account data for iframe id cvv"),
          oe("data-ifields-id", T).contentWindow.postMessage(i, "*"));
      }, 100);
    if (le(D))
      var s = setInterval(function () {
        B &&
          (clearInterval(s),
          de("Setting ifield account data for iframe id ach"),
          oe("data-ifields-id", D).contentWindow.postMessage(i, "*"));
      }, 100);
  }
  function fe(e, t) {
    Q[e] ? Q[e].push(t) : (Q[e] = [t]);
  }
  function he() {
    q = !0;
    var e = { action: "enableLogging" };
    if (le(A)) {
      let t = setInterval(function () {
        F &&
          (clearInterval(t),
          de("Enabling logging for iframe id card-number"),
          oe("data-ifields-id", A).contentWindow.postMessage(e, "*"));
      }, 100);
    }
    if (le(T))
      var t = setInterval(function () {
        O &&
          (clearInterval(t),
          de("Enabling logging for iframe id cvv"),
          oe("data-ifields-id", T).contentWindow.postMessage(e, "*"));
      }, 100);
    if (le(D))
      var n = setInterval(function () {
        B &&
          (clearInterval(n),
          de("Enabling logging for iframe id ach"),
          oe("data-ifields-id", D).contentWindow.postMessage(e, "*"));
      }, 100);
  }
  function ge() {
    ne = !0;
    let e = { action: "blockNonNumericInput" };
    if (le(A)) {
      let t = setInterval(function () {
        F &&
          (clearInterval(t),
          oe("data-ifields-id", A).contentWindow.postMessage(e, "*"));
      }, 100);
    }
  }
  function ye(e) {
    (ee = !0), (te = e = e || " ");
    let t = { action: "format", data: { formatChar: e } };
    if (le(A)) {
      let e = setInterval(function () {
        F &&
          (clearInterval(e),
          oe("data-ifields-id", A).contentWindow.postMessage(t, "*"));
      }, 100);
    }
  }
  function ve() {
    (X = !0), (_ = !1);
    let e = { action: "disable3DS", data: {} };
    if (le(A)) {
      let t = setInterval(function () {
        F &&
          (clearInterval(t),
          oe("data-ifields-id", A).contentWindow.postMessage(e, "*"));
      }, 100);
    }
  }
  function we(e, t) {
    var n;
    (Y = e),
      (Z = t),
      (_ = !0),
      (X = !1),
      t &&
        ((n = window.ck3DS),
        new Promise((e, t) => {
          if (void 0 !== n) return void e();
          const i = document.createElement("script");
          (i.src =
            "https://cdn.cardknox.com/sdk-3ds/1.0.2203.2501-beta/cardknox-3ds.min.js"),
            (i.async = !0),
            (i.integrity =
              "sha512-KyTN94lJ6O0BKK3ikGRI3CCmWGqShXNfwQvVBqHFXitmE8JI0JoG3Gz49pTmKEHXoy6//SWGZc9WWx9Eb7G63A=="),
            i.setAttribute("crossorigin", "anonymous"),
            (i.onload = () => {
              e();
            });
          const a = document.getElementsByTagName("script")[0];
          a.parentNode.insertBefore(i, a);
        })).then(() => {
          (ck3DS.configuration.onVerifyComplete = t),
            (ck3DS.configuration.enableConsoleLogging = q),
            ck3DS.initialized || ck3DS.initialize3DS(e);
        });
    let i = {
      action: "enable3DS",
      data: { environment: e, verificationEnabled: !!t },
    };
    if (le(A)) {
      let e = setInterval(function () {
        F &&
          (clearInterval(e),
          oe("data-ifields-id", A).contentWindow.postMessage(i, "*"));
      }, 100);
    }
  }
  window.addEventListener(
    "message",
    async function (e) {
      try {
        var t = e.data;
        if ("loaded" === t.action) {
          var n, i;
          de("Message received: ifield loaded");
          for (
            var o = document.getElementsByTagName("iframe"), s = 0;
            s < o.length;
            s++
          )
            if (o[s].contentWindow == e.source) {
              (n = o[s].getAttribute("data-ifields-id")),
                (i = o[s].getAttribute("data-ifields-placeholder"));
              break;
            }
          for (var r in (de("Loaded ifield id: " + n), q && he(), z))
            ce(r, z[r]);
          me(U, J, K),
            _ ? we(Y, Z) : X && ve(),
            n === A
              ? (re(e, n, L, i), (F = !0), ee && ye(te), ne && ge())
              : n === T
                ? (re(e, n, x, i), (O = !0))
                : n === D
                  ? (re(e, n, M, i), (B = !0))
                  : n === l
                    ? ((be.isFrameLoaded = !0),
                      be.isEnabled && !be.isButtonLoaded && be.load.call(be))
                    : n === a &&
                      ((Pe.isFrameLoaded = !0),
                      Pe.isAgreementLoaded || Pe.loadAgreement.call(Pe));
        } else if ("token" === t.action)
          de("Message received: token"),
            "error" === t.data.result
              ? ((j = new Date()),
                (oe("data-ifields-id", "card-data-error").innerHTML =
                  t.data.errorMessage))
              : t.data.xTokenType === L
                ? ((oe("data-ifields-id", "card-number-token").value =
                    t.data.xToken),
                  t.data.threeDSJwt &&
                    window.ck3DS &&
                    ck3DS.setJwt(t.data.threeDSJwt),
                  (N = !0))
                : t.data.xTokenType === x
                  ? ((oe("data-ifields-id", "cvv-token").value = t.data.xToken),
                    (G = !0))
                  : t.data.xTokenType === M &&
                    ((oe("data-ifields-id", "ach-token").value = t.data.xToken),
                    (W = !0));
        else if ("autoSubmit" === t.action)
          de("auto submitting form with id " + t.data.formId),
            document
              .getElementById(t.data.formId)
              .dispatchEvent(
                new Event("submit", { bubbles: !0, cancelable: !0 }),
              );
        else if ("update" === t.action) {
          if ((de("Message recieved: update"), t.xTokenType === L)) {
            if (t.data.ifieldValueChanged && le(T)) {
              var d = { action: "updateIssuer", issuer: t.data.issuer };
              oe("data-ifields-id", T).contentWindow.postMessage(d, "*");
            }
            (ie.cardNumberIsValid = t.data.isValid),
              (ie.cardNumberLength = t.data.cardNumberLength),
              (ie.cardNumberFormattedLength = t.data.length),
              (ie.cardNumberIsEmpty = t.data.isEmpty),
              (ie.issuer = t.data.issuer),
              (ie.triggeredByIfield = A),
              t.data.ifieldValueChanged && (ie.lastIfieldChanged = A);
          } else
            t.xTokenType === x
              ? ((ie.cvvIsValid = t.data.isValid),
                (ie.cvvLength = t.data.length),
                (ie.cvvIsEmpty = t.data.isEmpty),
                (ie.triggeredByIfield = T),
                t.data.ifieldValueChanged && (ie.lastIfieldChanged = T))
              : t.xTokenType === M &&
                ((ie.achLength = t.data.length),
                (ie.achIsEmpty = t.data.isEmpty),
                (ie.achIsValid = t.data.isValid),
                (ie.triggeredByIfield = D),
                t.data.ifieldValueChanged && (ie.lastIfieldChanged = D));
          u({ label: "ifieldDataCache", data: ie }),
            (ie.ifieldValueChanged = t.data.ifieldValueChanged);
          var p = Q[t.data.event];
          if (p)
            for (s = 0; s < p.length; s++)
              "function" == typeof p[s] &&
                p[s](Object.assign({ event: t.data.event }, ie));
        } else if ("event" === t.action) {
          let e = null;
          t.tokenType &&
            t.eventParams.server &&
            ((e = (function (e) {
              let t = null;
              switch (e) {
                case l:
                  t = be.iframeField;
                  break;
                case a:
                  t = Pe.iframeField;
              }
              return (
                (t && t.contentWindow) || (t = oe("data-ifields-id", e)), t
              );
            })(t.tokenType)),
            e && (e = e.contentWindow)),
            await v.handleEvent(c.client, t, e);
        } else t.action;
      } catch (t) {
        console.error(
          "Error message event listener for " + JSON.stringify(e),
          t,
        );
      }
    },
    !1,
  ),
    se();
  const be = {
      isFrameLoaded: !1,
      isEnabled: !1,
      environment: "",
      eventNames: [
        "onGPLoaded",
        "onGetShippingCosts",
        "onGetShippingOptions",
        "onGetTransactionInfo",
        "onBeforeProcessPayment",
        "onProcessPayment",
        "onPaymentCanceled",
        "onGPButtonLoaded",
      ],
      events: {},
      enableGooglePay: function (e) {
        (this.isDebug = e && e.isDebug),
          this.setIframeField(e && e.iframeField),
          (this.isFrameLoaded = e && e.isFrameLoaded),
          (this.initFunction = e && e.initFunction);
        let t = e && e.amountField;
        if (("string" == typeof t && (t = document.getElementById(t)), t)) {
          const e = function () {
            return parseFloat(t.value || "0");
          };
          let n = e();
          const i = function (t) {
            let i = e();
            i !== n && (be.updateAmount(), (n = i));
          };
          window.jQuery
            ? $(t).on(ae.join(","), i)
            : ae.forEach((e) => {
                t.addEventListener(e, i);
              });
        }
        (this.isEnabled = !0),
          (this.isButtonLoaded = !1),
          this.isFrameLoaded
            ? this.load()
            : (this.timeoutId = setTimeout(() => {
                se();
              }, 500));
      },
      updateAmount: function (e) {
        const t = be;
        if (!t.iframeField) {
          if (!e || !e.iframeField)
            throw "Failed to update Google Pay Amount. iframe with Google Pay button is not provided";
          t.setIframeField(e.iframeField);
        }
        v.executeEventHandler(this, {
          eventType: "function",
          eventName: "onGetTransactionInfo",
        })
          .then((e) => {
            if (!e)
              throw new Error(
                "Failed to update Google Pay Amount. Please try again",
              );
            if (!e.totalPrice || !e.displayItems)
              throw (
                (console.error(
                  "updateGooglePayAmount. Error getting transaction info",
                  e,
                ),
                new Error(
                  "Failed to update Google Pay Amount. Please check the logs",
                ))
              );
            const n = {
              client: { eventName: "onGetTransactionInfo", eventArgs: e },
            };
            v.submitEvent(l, n, t.iframeField);
          })
          .catch((e) => {
            throw (
              (console.error("updateGooglePayAmount. An error occurred", e),
              new Error(
                "Failed to update Google Pay Amount. Please check the logs",
              ))
            );
          });
      },
      setIframeField: function (e) {
        if (
          ((this.iframeField = e),
          "string" == typeof this.iframeField &&
            (this.iframeField =
              document.getElementById(this.iframeField) ||
              oe("data-ifields-id", this.iframeField)),
          (this.iframeField && this.iframeField.contentWindow) ||
            (this.iframeField = oe("data-ifields-id", l)),
          !this.iframeField)
        )
          throw "Cannot enable Google Pay. iframe with Google Pay button not found. Please refer to documentation.";
      },
      load: function () {
        if (!this.isEnabled) return;
        if (this.isButtonLoaded) return;
        let e = null;
        if ((this.initFunction && (e = m(this.initFunction)), !e)) {
          if (!this.iframeField)
            throw "Cannot load Google Pay. iframe with Google Pay button not found. Please refer to documentation.";
          if (
            !this.iframeField.attributes["data-ifields-oninit"] ||
            !this.iframeField.attributes["data-ifields-oninit"].value
          )
            throw "Invalid setup. 'data-ifields-oninit' attribute must be set for Google Pay ifield. Please refer to documentation";
          e = m(this.iframeField.attributes["data-ifields-oninit"].value);
        }
        let t = e();
        if (!t)
          throw "Invalid setup. 'data-ifields-oninit' must be a function that returns a valid object. Please refer to documentation";
        (this.environment = t.environment),
          (t.onGPLoaded = be.gpLoadedCallback.bind(be)),
          (t = this.setEvents(t)),
          (t.merchantInfo.merchantOrigin = window.location.hostname);
        const n = { action: "init", tokenType: l, params: t };
        this.iframeField.contentWindow.postMessage(n, "*");
      },
      setEvents: function (e) {
        if (!this.eventsLoaded) {
          if (
            ((e.assignedEvents = {}),
            this.eventNames.forEach((t) => {
              (this.events[t] = m(e[t])),
                "function" == typeof this.events[t] &&
                  ((e.assignedEvents[t] = !0), delete e[t]);
            }),
            e.shippingParameters.onGetShippingCosts &&
              ((this.events.onGetShippingCosts = m(
                e.shippingParameters.onGetShippingCosts,
              )),
              (e.assignedEvents.onGetShippingCosts = !0)),
            e.shippingParameters.onGetShippingOptions &&
              ((this.events.onGetShippingOptions = m(
                e.shippingParameters.onGetShippingOptions,
              )),
              (e.assignedEvents.onGetShippingOptions = !0)),
            "function" != typeof this.events.onGetTransactionInfo)
          )
            throw new Error(
              "onGetTransactionInfo is required. Please refer to documentation on the format",
            );
          if ("function" != typeof this.events.onProcessPayment)
            throw new Error(
              "onProcessPayment is required. Please refer to documentation",
            );
          if (
            ((e.shippingParameters &&
              "function" == typeof this.events.onGetShippingOptions) ||
              e.shippingParameters.defaultShippingOptions) &&
            "function" != typeof this.events.onGetShippingCosts
          )
            throw new Error(
              "onGetShippingCosts is required. Please refer to documentation on the format",
            );
          return e;
        }
      },
      gpLoadedCallback: function (e) {
        (this.isButtonLoaded = e && e.status === i.success),
          this.isButtonLoaded && clearTimeout(this.timeoutId),
          this.isDebug && console.log("GP isButtonLoaded", this.isButtonLoaded);
      },
      authorize: function (e) {
        return new Promise(function (t, n) {
          var i = new XMLHttpRequest();
          i.open("POST", "https://cardknoxdev.com/gpay/home/AuthorizeFull"),
            (i.onload = function () {
              this.status >= 200 && this.status < 300
                ? t(i.response)
                : n({ status: this.status, statusText: i.statusText });
            }),
            (i.onerror = function () {
              n({ status: this.status, statusText: i.statusText });
            }),
            i.setRequestHeader("Content-Type", "application/json"),
            i.send(JSON.stringify(e));
        });
      },
    },
    Ce = {
      isEnabled: !1,
      eventNames: [
        "onGetTransactionInfo",
        "onGetShippingMethods",
        "onShippingContactSelected",
        "onShippingMethodSelected",
        "onPaymentMethodSelected",
        "onValidateMerchant",
        "onBeforeProcessPayment",
        "onPaymentAuthorize",
        "onPaymentComplete",
        "onAPButtonLoaded",
        "onError",
      ],
      events: {},
      enableApplePay: function (e) {
        (this.isDebug = e && e.isDebug), (window.apReq = null);
        try {
          const t = m(e && e.initFunction);
          if (!t)
            throw new Error(
              "initFunction is required. Must be a function to initialize Apple Pay",
            );
          if (((window.apReq = t()), !window.apReq))
            throw "Invalid response from init function. Please refer to documentation";
          this.setEvents(window.apReq), b.init(window.apReq);
        } catch (e) {
          throw `Cannot enable Apple Pay: ${e}`;
        }
        let t = e && e.amountField;
        if (
          ("string" == typeof t && (t = document.getElementById(t)),
          t && window.apReq)
        ) {
          const e = function () {
            return f(t.value || "0", 2);
          };
          let n = e();
          const i = this,
            a = async function (t) {
              try {
                let t = e();
                t !== n && (Ce.updateAmount(), (n = t));
              } catch (e) {
                console.error("Amount Change failed:", y(e)),
                  i.isDebug && alert("Amount Change failed: " + y(e));
              }
            };
          window.jQuery
            ? $(t).on(ae.join(","), a)
            : ae.forEach((e) => {
                t.addEventListener(e, a);
              });
        }
        (this.isEnabled = !0), se();
      },
      updateAmount: function () {
        window.apReq &&
          v
            .submitLocalEvent(this, "onGetTransactionInfo")
            .then((e) => {
              if (!e)
                throw "Failed to update Apple Pay Amount. Please try again";
              const t = v.getEventOwner(c.server, o);
              v.submitLocalEvent(t, "onTransactionInfo", e).catch((e) => {
                throw e;
              });
            })
            .catch((e) => {
              throw (
                (console.error("updateApplePayAmount. An error occurred", e),
                "Failed to update Apple Pay Amount. please check the logs")
              );
            });
      },
      setEvents: function (e) {
        if (!this.eventsLoaded) {
          if (
            (this.eventNames.forEach((t) => {
              (this.events[t] = m(e[t])),
                "function" == typeof this.events[t] ? (e[t] = !0) : delete e[t];
            }),
            (this.eventsLoaded = !0),
            "function" != typeof this.events.onGetTransactionInfo)
          )
            throw new Error(
              "onGetTransactionInfo is required. Must be a name of a function (or function itself) that returns a line item(ApplePayLineItem) representing the total for the payment. For more info please refer to documentation",
            );
          if ("function" != typeof this.events.onValidateMerchant)
            throw new Error(
              "onValidateMerchant is required. Must be a name of a function (or function itself) that validates  Apple Pay session. For more info please refer to documentation",
            );
          if ("function" != typeof this.events.onPaymentAuthorize)
            throw new Error(
              "onPaymentAuthorize is required. Must be a name of a function (or function itself) that authorizes payment with Gateway. For more info please refer to documentation",
            );
        }
      },
    };
  window.applePaySdk = b;
  const Pe = {
      events: {},
      isAgreementEnabled: !1,
      enableAgreement: function (e) {
        (this.isAgreementEnabled = !0),
          (this.isDebug = e && e.isDebug),
          this.setIframeField(e && e.iframeField),
          this.setEvents(e),
          (this.reqAgreement = Object.assign(
            {},
            {
              xKey: e.xKey,
              autoAgree: e.autoAgree,
              agreementType: e.agreementType,
              referrer: window.location.toString(),
              isDebug: e.isDebug,
            },
          )),
          this.validate(),
          (this.isAgreementLoaded = !1),
          this.isFrameLoaded
            ? this.loadAgreement()
            : setTimeout(() => {
                se();
              }, 100);
      },
      setEvents: function (e) {
        (this.events.onStatusChanged = m(e.onStatusChanged)),
          (this.events.onAgreementLoaded = this.onAgreementLoaded.bind(this)),
          (this.events.onSendAcceptance = !0);
      },
      validate: function () {
        if (this.reqAgreement.autoAgree && !this.events.onStatusChanged)
          throw new Error(
            "onStatusChanged event handler (callback function) is required when autoAgree is 'true'",
          );
        if (!this.reqAgreement.xKey) throw new Error("xKey is required");
      },
      loadAgreement: function () {
        if (!this.isAgreementEnabled) return;
        const e = { tokenType: a, action: "init", params: this.reqAgreement };
        this.iframeField.contentWindow.postMessage(e, "*");
      },
      getToken: function () {
        return new Promise((e, t) => {
          v.buildEvent(
            this,
            a,
            "onSendAcceptance",
            void 0,
            void 0,
            this.iframeField,
          )
            .then((t) => {
              e(t);
            })
            .catch((e) => {
              t(e);
            });
        });
      },
      setIframeField: function (e) {
        if (
          ((this.iframeField = e),
          "string" == typeof this.iframeField &&
            (this.iframeField =
              document.getElementById(this.iframeField) ||
              oe("data-ifields-id", this.iframeField)),
          (this.iframeField && this.iframeField.contentWindow) ||
            (this.iframeField = oe("data-ifields-id", a)),
          !this.iframeField)
        )
          throw "Cannot enable Customer Agreement. iframe with Customer Agreement not found. Please refer to documentation.";
      },
      onAgreementLoaded: function (e) {
        e &&
          e.status !== i.success &&
          console.error("Failed to load Customer Agreement", e.statusText),
          (this.isAgreementLoaded = e && e.status === i.success);
      },
    },
    Ee = {
      APButtonColor: s,
      APButtonType: r,
      APRequiredFeatures: d,
      GPBillingAddressFormat: { min: "MIN", full: "FULL" },
      GPButtonSizeMode: { static: "static", fill: "fill" },
      GPButtonType: {
        buy: "buy",
        donate: "donate",
        plain: "plain",
        pay: "pay",
        book: "book",
        checkout: "checkout",
        order: "order",
        subscribe: "subscribe",
      },
      GPEnvironment: { test: "TEST", production: "PRODUCTION" },
      c2pEnvironment: C,
      iStatus: i,
      APErrorCode: {
        shippingContactInvalid: "shippingContactInvalid",
        billingContactInvalid: "billingContactInvalid",
        addressUnserviceable: "addressUnserviceable",
        couponCodeInvalid: "couponCodeInvalid",
        couponCodeExpired: "couponCodeExpired",
        unknown: "unknown",
      },
      APErrorContactField: {
        phoneNumber: "phoneNumber",
        emailAddress: "emailAddress",
        name: "name",
        phoneticName: "phoneticName",
        postalAddress: "postalAddress",
        addressLines: "addressLines",
        locality: "locality",
        subLocality: "subLocality",
        postalCode: "postalCode",
        administrativeArea: "administrativeArea",
        subAdministrativeArea: "subAdministrativeArea",
        country: "country",
        countryCode: "countryCode",
      },
      exMsg: y,
      isDebugEnv: n,
      logDebug: u,
      logError: p,
      parseQueryString: function (e) {
        let t = {};
        return (
          e.replace(
            new RegExp("([^?=&]+)(=([^&]*))?", "g"),
            function (e, n, i, a) {
              t[n] = a;
            },
          ),
          t
        );
      },
      roundTo: f,
      roundToNumber: h,
      addIfieldCallback: fe,
      addIfieldKeyPressCallback: function (e) {
        fe("input", e);
      },
      clearIfield: function (e) {
        de("Clearing ifield data for iframe id " + e),
          oe("data-ifields-id", e).contentWindow.postMessage(
            { action: "clearData" },
            "*",
          );
      },
      disable3DS: ve,
      enable3DS: we,
      enableApplePay: function (e) {
        Ce.enableApplePay(e);
      },
      enableAutoFormatting: ye,
      enableAutoSubmit: function (e) {
        if (0 == ((t = e), null != document.getElementById(t)))
          throw "Invalid formId (" + e + ")";
        var t,
          n = { action: "enableAutoSubmit", data: { formId: e } };
        if (le(A))
          var i = setInterval(function () {
            F &&
              (clearInterval(i),
              oe("data-ifields-id", A).contentWindow.postMessage(n, "*"));
          }, 100);
        if (le(T))
          var a = setInterval(function () {
            O &&
              (clearInterval(a),
              oe("data-ifields-id", T).contentWindow.postMessage(n, "*"));
          }, 100);
        if (le(D))
          var o = setInterval(function () {
            B &&
              (clearInterval(o),
              oe("data-ifields-id", D).contentWindow.postMessage(n, "*"));
          }, 100);
      },
      enableBlockNonNumericInput: ge,
      enableGooglePay: function (e) {
        be.enableGooglePay.call(be, e);
      },
      enableLogging: he,
      focusIfield: function (e) {
        le(e) &&
          oe("data-ifields-id", e).contentWindow.postMessage(
            { action: "focus" },
            "*",
          );
      },
      getTokens: function (e, t, n) {
        (n = n || 6e4),
          (e = e || Function.prototype),
          (t = t || Function.prototype),
          (N = !1),
          (G = !1),
          (W = !1),
          le(A) && (oe("data-ifields-id", "card-number-token").value = ""),
          le(T) && (oe("data-ifields-id", "cvv-token").value = ""),
          le(D) && (oe("data-ifields-id", "ach-token").value = ""),
          ue(""),
          (H = !1);
        var i = { action: "getToken" };
        if (le(A))
          var a = setInterval(function () {
            F &&
              (clearInterval(a),
              oe("data-ifields-id", A).contentWindow.postMessage(i, "*"));
          }, 100);
        if (le(T))
          var o = setInterval(function () {
            O &&
              (clearInterval(o),
              oe("data-ifields-id", T).contentWindow.postMessage(i, "*"));
          }, 100);
        if (le(D))
          var s = setInterval(function () {
            B &&
              (clearInterval(s),
              oe("data-ifields-id", D).contentWindow.postMessage(i, "*"));
          }, 100);
        var r = le(A),
          d = le(T),
          l = le(D),
          c = setInterval(function () {
            (0 != r && !N) ||
              (0 != d && !G) ||
              (0 != l && !W) ||
              (clearInterval(c), (H = !0), ue(""), e());
          }, 100),
          u = new Date().getTime(),
          p = setInterval(function () {
            var e = new Date().getTime();
            u < j
              ? (clearInterval(a),
                clearInterval(o),
                clearInterval(s),
                clearInterval(p),
                clearInterval(c),
                t())
              : H
                ? clearInterval(p)
                : e - u > n &&
                  (clearInterval(a),
                  clearInterval(o),
                  clearInterval(s),
                  clearInterval(p),
                  clearInterval(c),
                  (oe("data-ifields-id", "card-data-error").innerHTML =
                    "Transaction timed out"),
                  t());
          }, 100);
      },
      setAccount: me,
      setError: ue,
      setIfieldStyle: ce,
      setPlaceholder: pe,
      verify3DS: function (e) {
        void 0 !== window.ck3DS
          ? ck3DS.verifyTrans(e)
          : de(
              "verify3DS called without using enable3DS first to attach a handler!",
            );
      },
      ckApplePay: Ce,
      ckClick2Pay: {
        enableClickToPay: function (e) {
          if (!e) throw "Click-To-Pay parameters required";
          this.isDebug = e.isDebug;
          let t = null;
          try {
            const n = m(e.initFunction);
            if (((t = "function" == typeof n ? n() : e), !t))
              throw "Invalid response from init function. Please refer to documentation";
            k.init(t);
          } catch (e) {
            throw `Cannot enable Click-To-Pay: ${e}`;
          }
        },
      },
      ckCustomerAgreement: Pe,
      ckGooglePay: be,
    };
  Object.assign(window, Ee);
  const Se = Ee;
  window.ifields = t;
})();

const gpRequest = {
  environment: GPEnvironment.test,
  merchantInfo: {
    merchantName: "GiveSanta.com",
  },
  buttonOptions: {
    buttonSizeMode: GPButtonSizeMode.fill,
  },
  billingParams: {
    billingAddressRequired: false,
  },
  shippingParameters: {
    shippingAddressRequired: false,
  },
  onGetTransactionInfo: function () {
    let totalPrice = document.getElementById("totalPrice").value;
    return {
      displayItems: [
        {
          label: "Subtotal",
          type: "SUBTOTAL",
          price: totalPrice.toString(),
        },
      ],
      countryCode: "US",
      currencyCode: "USD",
      totalPriceStatus: "FINAL",
      totalPrice: totalPrice.toString(),
      totalPriceLabel: "Total",
    };
  },
  onBeforeProcessPayment: function () {
    ckGooglePay.updateAmount("totalPrice");
    return new Promise(function (resolve, reject) {
      try {
        resolve(iStatus.success);
      } catch (err) {
        reject(err);
      }
    });
  },
  onProcessPayment: function (paymentResponse) {
    return new Promise(function (resolve, reject) {
      try {
        let paymentToken =
          paymentResponse.paymentData.paymentMethodData.tokenizationData.token;
        const amt =
          (paymentResponse &&
            paymentResponse.transactionInfo &&
            paymentResponse.transactionInfo.totalPrice) ||
          0;
        if (amt <= 0) {
          throw "Payment is not authorized. Invalid amount. Amount must be greater than 0";
        }
        const tokenElement = document.getElementById("googleToken");
        tokenElement.value = paymentToken;
        tokenElement.dispatchEvent(new Event("input", { bubbles: true }));
        resolve();
      } catch (err) {
        reject();
      }
    });
  },
  onPaymentCanceled: function (respCanceled) {},
};

function initGP() {
  return {
    merchantInfo: gpRequest.merchantInfo,
    buttonOptions: gpRequest.buttonOptions,
    billingParameters: gpRequest.billingParams,
    shippingParameters: gpRequest.shippingParameters,
    onGetTransactionInfo: gpRequest.onGetTransactionInfo,
    environment: gpRequest.environment,
    onBeforeProcessPayment: gpRequest.onBeforeProcessPayment,
    onProcessPayment: gpRequest.onProcessPayment,
    onPaymentCanceled: gpRequest.onPaymentCanceled,
    onGPButtonLoaded: "gpButtonLoaded",
  };
}

function gpSetEnvironment(env = "test") {
  gpRequest.environment =
    env === "production" ? GPEnvironment.production : GPEnvironment.test;
}

function loadApple() {
  ckApplePay.enableApplePay({
    initFunction: apRequest.initAP,
    amountField: "totalPrice",
  });
}

const apRequest = {
  merchantIdentifier: "merchant.cardknoxdev.com",
  buttonOptions: {
    buttonContainer: "ap-container",
    buttonColor: APButtonColor.black,
    buttonType: APButtonType.pay,
  },
  totalAmount: null,
  taxAmt: null,
  shippingMethod: null,
  creditType: null,
  getTransactionInfo: function (taxAmt, shippingMethod, creditType) {
    try {
      apRequest.shippingMethod = shippingMethod ||
        apRequest.shippingMethod || {
          label: "Free Shipping",
          amount: "0.00",
          type: "final",
        };
      apRequest.taxAmt = roundToNumber(taxAmt, 4) || apRequest.taxAmt || 0.07;
      apRequest.creditType = creditType || apRequest.creditType;
      const amt = getAmount();
      const lineItems = [
        {
          label: "Subtotal",
          type: "final",
          amount: amt,
        },
        apRequest.shippingMethod,
      ];
      let totalAmt = 0;
      lineItems.forEach((item) => {
        totalAmt += parseFloat(item.amount) || 0;
      });
      totalAmt = roundTo(totalAmt, 2);
      apRequest.totalAmount = totalAmt;

      return {
        lineItems: lineItems,
        total: {
          type: "final",
          label: "Total",
          amount: totalAmt,
        },
      };
    } catch (err) {
      console.error("getTransactionInfo error ", exMsg(err));
    }
  },
  onGetTransactionInfo: function () {
    try {
      return apRequest.getTransactionInfo();
    } catch (err) {
      console.error("onGetTransactionInfo error ", exMsg(err));
    }
  },
  onValidateMerchant: function (validationUrl) {
    return new Promise(function (resolve, reject) {
      try {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "https://api.cardknox.com/applepay/validate");
        xhr.onload = function () {
          if (this.status >= 200 && this.status < 300) {
            console.log(
              "validateApplePayMerchant",
              JSON.stringify(xhr.response),
            );
            resolve(xhr.response);
          } else {
            console.error(
              "validateApplePayMerchant",
              JSON.stringify(xhr.response),
              this.status,
            );
            reject({
              status: this.status,
              statusText: xhr.response,
            });
          }
        };
        xhr.onerror = function () {
          console.error(
            "validateApplePayMerchant",
            xhr.statusText,
            this.status,
          );
          reject({
            status: this.status,
            statusText: xhr.statusText,
          });
        };
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send();
      } catch (err) {
        setTimeout(function () {
          console.log("getApplePaySession error: " + exMsg(err));
        }, 100);
      }
    });
  },
  authorize: function (applePayload, totalAmount) {
    return new Promise(function (resolve, reject) {
      try {
        if (totalAmount <= 0) {
          throw "Payment is not authorized. Invalid amount. Amount must be greater than 0";
        }
        const tokenElement = document.getElementById("appleToken");
        console.log(applePayload);
        console.log(applePayload.token.paymentData);
        console.log(JSON.stringify(applePayload?.token?.paymentData, null, 2));

        tokenElement.value = JSON.stringify(
          applePayload?.token?.paymentData,
          null,
          2,
        );
        tokenElement.dispatchEvent(new Event("input", { bubbles: true }));
        resolve();
      } catch (err) {
        reject();
      }
    });
  },
  onPaymentAuthorize: function (applePayload) {
    return new Promise((resolve, reject) => {
      try {
        apRequest
          .authorize(applePayload, apRequest.totalAmount)
          .then(() => {
            try {
              resolve();
            } catch (err) {
              throw err;
            }
          })
          .catch((err) => {
            console.error("authorizeAPay error.", JSON.stringify(err));
            reject(err);
          });
      } catch (err) {
        console.error("onPaymentAuthorize error.", JSON.stringify(err));
        reject(err);
      }
    });
  },
  onPaymentComplete: function (paymentComplete) {},
  initAP: function () {
    return {
      buttonOptions: apRequest.buttonOptions,
      merchantIdentifier: apRequest.merchantIdentifier,
      requiredBillingContactFields: [],
      requiredShippingContactFields: [],
      onGetTransactionInfo: apRequest.onGetTransactionInfo,
      onValidateMerchant: apRequest.onValidateMerchant,
      onPaymentAuthorize: apRequest.onPaymentAuthorize,
      onPaymentComplete: apRequest.onPaymentComplete,
      onAPButtonLoaded: apRequest.apButtonLoaded,
      isDebug: apRequest.merchantIdentifier === "test",
    };
  },
  apButtonLoaded: function (resp) {
    if (!resp) return;
    if (resp.status === iStatus.success) {
      showHide(apRequest.buttonOptions.buttonContainer, true);
    } else if (resp.reason) {
      console.log(resp.reason);
    }
  },
};

function showHide(elem, toShow) {
  if (typeof elem === "string") {
    elem = document.getElementById(elem);
  }
  if (elem) {
    toShow ? elem.classList.remove("hidden") : elem.classList.add("hidden");
  }
}

function getAmount() {
  return roundToNumber(document.getElementById("totalPrice").value || "0", 2);
}

function apSetEnvironment(env = "test") {
  apRequest.merchantIdentifier =
    env === "production" ? "merchant.cardknox.com" : "merchant.cardknoxdev.com";
}
